import { Form, Modal } from 'react-bootstrap-5';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { post, put } from 'helpers/api';
import ErrorAlert from '../../../project/components/new_listing_modal/error_alert';
import { Button } from 'components/ui/button';
import { getChildCompanyIdFromUrl } from '../shared';

export default function EditModal(props) {
  const [title, setTitle] = useState(props.title || '');
  const [errors, setErrors] = useState([]);
  const [isSubmitted, setIsSubmitting] = useState(false);
  const canSubmitForm = title.length > 0;

  async function submitForm(e) {
    e.preventDefault();

    if (!canSubmitForm) {
      return;
    }

    setIsSubmitting(true);
    setErrors([]);

    const { fetchMethod, url } = fetchParams();
    try {
      const brokerSpecialtyArguments = { title };
      const res = await fetchMethod(url, { broker_specialty: brokerSpecialtyArguments });
      setIsSubmitting(false);
      if (res.id) {
        props.onSuccessfulFormSubmit(res);
      } else {
        setErrors(res);
      }
    } catch {
      setIsSubmitting(false);
      const uploadType = props.id === '' ? 'created' : 'updated';
      setErrors([`Specialty could not be ${uploadType}. Please try again or contact support for help.`]);
    }
  }

  function fetchParams() {
    const childCompanyId = getChildCompanyIdFromUrl();
    const urlSuffix = childCompanyId ? `?child_company_id=${childCompanyId}` : '';

    if (props.id === '') {
      return { fetchMethod: post, url: `/broker_specialties${urlSuffix}` };
    }

    return { fetchMethod: put, url: `/broker_specialties/${props.id}${urlSuffix}` };
  }

  return (
    <Modal.Body className="p-5">
      <h5 className="text-center mt-0 mb-4">{props.id === '' ? 'Add a' : 'Edit'} Specialty</h5>
      <ErrorAlert errorMessages={errors} hasErrors={errors.length > 0}/>
      <Form onSubmit={submitForm}>
        <Form.Group controlId="specialty-initials">
          <Form.Label className="mb-1">Add Specialty Initials</Form.Label>
          <Form.Control
            autoFocus
            placeholder="Enter specialty title"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </Form.Group>

        <div className="mt-5 d-flex gap-3 justify-content-end">
          <Button disabled={isSubmitted} type="button" variant="ghost" onClick={props.onCloseModal}>Cancel</Button>
          <Button disabled={!canSubmitForm || isSubmitted} type="submit">
            {props.id === '' ? 'Add' : 'Update'} Specialty
          </Button>
        </div>
      </Form>
    </Modal.Body>
  );
}

EditModal.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  title: PropTypes.string,
  onCloseModal: PropTypes.func.isRequired,
  onSuccessfulFormSubmit: PropTypes.func.isRequired,
};
